/*
---
name: Shrinker

author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var StyledCheckbox = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_styled_checkbox'
	},

	initialize: function(element, options){
		this.setOptions(options);
		this._element = element;

		if(this._element){
			this.build();
		}
	},

	build: function(){
		var self = this;

		this._input = this._element.getElement('input[type="checkbox"]');//.hide();

		this._input.setStyles({
			'position': 'absolute',
			'left': -10000
		});

		var _label = this._element.getElement('label').dispose();
		var label_text = (_label)? _label.get('html') : this._input.get('value');

		if(!label_text || label_text == '') label_text = 'checkbox';

		this._checkbox = new Element('.monitor', {'html': '<i class="fa fa-square-o" aria-hidden="true"></i>' +
			'<i class="fa fa-check-square" aria-hidden="true"></i>' +
			label_text});

		if(this._element.hasClass('_block')){
			this.block_shape = true;
		}

		if(this.block_shape){
			this.default_bkg = this._checkbox.getStyle('background-color');
		}

		this._element.adopt(this._checkbox);

		this._element.addEvents({
			'click': this.toggle_select.bind(this)
		});

		this._input.addEvents({
			'focus': function(){
				self._element.addClass('_focused');
			},

			'blur': function(){
				self._element.removeClass('_focused');
			}
		});

		if(this._input.checked){
			this._checkbox.addClass('_checked');

			if(!this.block_shape) return;

			var db = this._checkbox.getAttribute('data-background');

			if(!db || (db != 'none' && db != false && db != 'false')){
				this._checkbox.setStyle('background-color', this._checkbox.getStyle('border-top-color'));
			}
		}
	},

	toggle_select: function(){
		this._checkbox.toggleClass('_checked');

		this._input.fireEvent('change');

		if(this._checkbox.hasClass('_checked')){
			this._input.checked = true;

			if(!this.block_shape) return;

			var db = this._checkbox.getAttribute('data-background');

			if(!db || (db != 'none' && db != false && db != 'false')){
				this._checkbox.setStyle('background-color', this._checkbox.getStyle('border-top-color'));
			}
		}else{
			this._input.checked = false;

			if(!this.block_shape) return;

			this._checkbox.setStyle('background-color', this.default_bkg);
		}
	}
});
